import axios from "shared/lib/GolAxios";
import { createResponse } from "shared/lib/functions";
import { getCountriesRequestObject } from "shared/lib/golRequestObjects";

export async function getCountries({ includeStates }) {
  const request = await getCountriesRequestObject({ includeStates });
  const response = await axios.post("", request);

  return createResponse(response);
}
